@let error = this.communicationError$ | async;
<cam-loader [isLoading]="this.requestState.isLoading()">
  <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
    <cam-empty [isEmpty]="!error">
      @if (error) {
        <div class="content flex-column">
          <div>
            <cam-title [level]="4" [isBold]="true">
              {{ 'communication.message.system.error.subject' | translate }}
            </cam-title>
            <cam-text size="md">
              {{ error.communicationSubject }}
            </cam-text>
          </div>
          <div>
            <cam-title [level]="4" [isBold]="true">
              {{ 'communication.message.system.error.error' | translate }}
            </cam-title>
            <cam-text size="md">
              {{ error.error }}
            </cam-text>
          </div>
        </div>
      }
    </cam-empty>
  </cam-error>
</cam-loader>
